export default __webpack_public_path__ + "static/media/fotosintese.0a377368.jpeg";